import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandName";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#E5E5E5] bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <div className="grid sm:grid-cols-3 gap-10 sm:gap-16">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block">
              <img
                src="https://customer-assets.emergentagent.com/job_padel-shop-4/artifacts/98zuvpdj_Wordmark%20%2B%20dot%20-%20White.svg"
                alt="Padlr."
                className="h-5 sm:h-6 invert"
              />
            </Link>
            <p className="mt-4 text-sm text-[#888] tracking-wide leading-relaxed">
              Better Than Yesterday.
              <br />
              Designed in Switzerland.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-[#aaa] mb-5" style={{ fontStyle: "normal" }}>
              Navigate
            </p>
            <div className="flex flex-col gap-3">
              <Link to="/shop" className="text-sm text-[#0A0A0A] hover:opacity-60 transition-opacity tracking-wide">Shop</Link>
              <Link to="/about" className="text-sm text-[#0A0A0A] hover:opacity-60 transition-opacity tracking-wide">About</Link>
            </div>
          </div>

          {/* Social */}
          <div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-[#aaa] mb-5" style={{ fontStyle: "normal" }}>
              Follow Us
            </p>
            <div className="flex flex-col gap-3">
              <a href="https://www.instagram.com/padlr.official/" target="_blank" rel="noopener noreferrer"
                data-testid="social-instagram" className="text-sm text-[#0A0A0A] hover:opacity-60 transition-opacity tracking-wide">
                Instagram
              </a>
              <a href="https://www.tiktok.com/@padlr" target="_blank" rel="noopener noreferrer"
                data-testid="social-tiktok" className="text-sm text-[#0A0A0A] hover:opacity-60 transition-opacity tracking-wide">
                TikTok
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-6 border-t border-[#E5E5E5] flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-[#aaa]" style={{ fontStyle: "normal" }}>
            &copy; {new Date().getFullYear()} <BrandLogo color="#aaa" /> All rights reserved.
          </p>
          <p className="text-xs text-[#aaa]" style={{ fontStyle: "normal" }}>
            info@padlr.co
          </p>
        </div>
      </div>
    </footer>
  );
}
